import { AuthContext } from "providers/AuthProvider";
import { useContext } from "react";
import ResponsiveHomeLayout from "./ResponsiveHomeLayout";
import ResponsiveHomeLayout2 from "./ResponsiveHomeLayout2";

function ResponsiveHomeLayoutType() {
    const { userName } = useContext(AuthContext);

    return (
        <>
            {
                userName
                    ?
                    <ResponsiveHomeLayout />
                    :
                    <ResponsiveHomeLayout2 />
            }
        </>
    );
}

export default ResponsiveHomeLayoutType;